import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import { Button } from '../../components/ui/button';
import * as LucideIcons from 'lucide-react';
import { ArrowLeft, MessageCircle, Plus } from 'lucide-react';
import { toast } from 'sonner';

export default function ForumIndex() {
  const navigate = useNavigate();
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getForumCategories().then(setCats).catch((e) => {
      toast.error(e.detail || 'Erreur de chargement');
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-5" data-testid="forum-index">
      <Button onClick={() => navigate('/reseau')} variant="ghost" size="sm" className="-ml-2">
        <ArrowLeft className="w-4 h-4 mr-1" /> Retour au réseau
      </Button>

      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-3xl font-black flex items-center gap-2">
            <MessageCircle className="w-7 h-7 text-[hsl(var(--primary))]" />
            Forum ECSR
          </h1>
          <p className="text-sm text-muted-foreground mt-1">8 catégories pour discuter pédagogie, méthodes, pratique.</p>
        </div>
      </div>

      {loading ? (
        <div className="mc-card p-10 text-center text-muted-foreground">Chargement…</div>
      ) : (
        <div className="grid md:grid-cols-2 gap-3" data-testid="forum-categories-list">
          {cats.map(c => {
            const Icon = LucideIcons[c.icon] || MessageCircle;
            return (
              <button
                key={c.slug}
                onClick={() => navigate(`/reseau/forum/${c.slug}`)}
                data-testid={`forum-cat-${c.slug}`}
                className="mc-card p-4 text-left hover:-translate-y-0.5 hover:shadow-lg transition-all"
              >
                <div className="flex items-start gap-3">
                  <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: `${c.color}15`, color: c.color }}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-black text-base">{c.name}</div>
                    <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{c.description}</p>
                    <div className="flex items-center gap-3 mt-2 text-[10px] font-bold text-muted-foreground">
                      <span>{c.thread_count} discussion(s)</span>
                      <span>{c.post_count} message(s)</span>
                      {c.last_thread && <span className="truncate">↳ {c.last_thread.title?.slice(0, 40)}</span>}
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
